import { Component, OnInit, HostBinding } from '@angular/core';
import { IndexService, CardSize } from '../index.service';

export interface PeriodicElement {
	uid: number;
	name: string;
	portrait: string;
	address: string;
	code: string;
	phone: number;
	duty: string;
	remark: string;
}
const ELEMENT_DATA: PeriodicElement[] = [
	{
		uid: 1,
		name: 'Jon',
		portrait: '/front/assets/userinfo/portrait_default.png',
		address: 'æ­å·è¥¿æ¹åºæ­å·è¥¿æ¹åºæ­å·è¥¿æ¹åºæ­å·è¥¿æ¹åºæ­å·è¥¿æ¹åºæ­å·è¥¿æ¹åº',
		code: 'G2H636W',
		phone: 25692615,
		duty: 'é¨é¿',
		remark: '111111111'
	},
	{
		uid: 2,
		name: 'TUDM',
		portrait: '/front/assets/userinfo/portrait_default.png',
		address: 'æ­å·ä½æ­åºæ­å·ä½æ­åºæ­å·ä½æ­åº',
		code: 'G2H636W',
		phone: 25692615,
		duty: 'ç»é¿',
		remark: '555555'
	},
	{
		uid: 3,
		name: 'MMMM',
		portrait: '/front/assets/userinfo/portrait_default.png',
		address: 'æ­å·ä½æ­åºæ­å·ä½æ­åºæ­å·ä½æ­åº',
		code: 'G2H636W',
		phone: 25692625,
		duty: 'ç»é¿',
		remark: 'å¤æ³¨'
	},
	{
		uid: 1,
		name: 'Jon',
		portrait: '/front/assets/userinfo/portrait_default.png',
		address: 'æ­å·è¥¿æ¹åºæ­å·è¥¿æ¹åºæ­å·è¥¿æ¹åº',
		code: 'G2H636W',
		phone: 25692615,
		duty: 'é¨é¿',
		remark: 'å¤æ³¨'
	},
	{
		uid: 2,
		name: 'TUDM',
		portrait: '/front/assets/userinfo/portrait_default.png',
		address: 'æ­å·ä½æ­åºæ­å·ä½æ­åºæ­å·ä½æ­åº',
		code: 'G2H636W',
		phone: 25692615,
		duty: 'ç»é¿',
		remark: 'å¤æ³¨'
	},
	{
		uid: 3,
		name: 'MMMM',
		portrait: '/front/assets/userinfo/portrait_default.png',
		address: 'æ­å·ä½æ­åºæ­å·ä½æ­åºæ­å·ä½æ­åº',
		code: 'G2H636W',
		phone: 25692625,
		duty: 'ç»é¿',
		remark: 'å¤æ³¨'
	}
];
@Component({
	selector: 'common-data-list',
	templateUrl: './data-list.component.html',
	styleUrls: ['./data-list.component.scss']
})
export class DataListComponent implements OnInit {
	@HostBinding('class.c-index-data-list') hostClass = true;
	navName = 'datalist';
	navSize: CardSize;

	displayedColumns: string[] = ['id', 'name', 'portrait', 'address', 'code', 'phone', 'duty', 'remark'];
	dataSource = ELEMENT_DATA;

	constructor(public svr: IndexService) {
		this.navSize = this.svr.userSetting.Cards.find(x => x.Type === this.navName).Size;
	}

	ngOnInit() {}
}
